export default __webpack_public_path__ + "static/media/successful-small-cricle-icon.b624bde7.svg";